module.exports = __webpack_public_path__ + "static/media/drawIcon.55dc4421.svg";